import { render, staticRenderFns } from "./ScrollToTopButton.vue?vue&type=template&id=a5dafe5e&scoped=true"
import script from "./ScrollToTopButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScrollToTopButton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ScrollToTopButton.vue?vue&type=style&index=0&id=a5dafe5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5dafe5e",
  null
  
)

export default component.exports